import {
  AppWindow, Bell, BookText, Box, Building2, Calendar, ClipboardCheck, ClipboardList, Clock, Cpu, Database,
  DollarSign, Download, ExternalLink, FileText, Folder, Globe, GitBranch, HardDrive, Headphones, KeyRound,
  Laptop, Layers, LayoutDashboard, LogOut, Mail, MapPin, Monitor, Move, Network, Package, Printer, Receipt,
  Search, Send, Server, Settings, Shield, ShieldCheck, Smartphone, Star, Ticket, Truck, UserPlus, Users,
  Wallet, Wifi, Wrench,
  type LucideIcon,
} from 'lucide-react';

export interface IconEntry {
  key: string;
  label: string;
  Icon: LucideIcon;
}

/**
 * The icons a menu item may use — what the Menu config picker offers and what
 * the sidebar renders (one list, so the two can't drift). The key is the string
 * stored in oscar.MenuItem.Icon; every key migration 131 seeds is here
 * (fallback.test.ts checks). An unknown key renders as a document, so a typo
 * never blanks a row.
 */
export const ICON_LIBRARY: IconEntry[] = [
  { key: 'laptop', label: 'Laptop', Icon: Laptop },
  { key: 'monitor', label: 'Monitor', Icon: Monitor },
  { key: 'smartphone', label: 'Phone', Icon: Smartphone },
  { key: 'printer', label: 'Printer', Icon: Printer },
  { key: 'server', label: 'Server', Icon: Server },
  { key: 'hard-drive', label: 'Drive', Icon: HardDrive },
  { key: 'cpu', label: 'Chip', Icon: Cpu },
  { key: 'wifi', label: 'Wi-Fi', Icon: Wifi },
  { key: 'network', label: 'Network', Icon: Network },
  { key: 'layers', label: 'Layers', Icon: Layers },
  { key: 'database', label: 'Database', Icon: Database },
  { key: 'app-window', label: 'Application', Icon: AppWindow },
  { key: 'key-round', label: 'Key', Icon: KeyRound },
  { key: 'users', label: 'People', Icon: Users },
  { key: 'user-plus', label: 'New person', Icon: UserPlus },
  { key: 'log-out', label: 'Leaving', Icon: LogOut },
  { key: 'git-branch', label: 'Branch', Icon: GitBranch },
  { key: 'building', label: 'Building', Icon: Building2 },
  { key: 'map-pin', label: 'Location', Icon: MapPin },
  { key: 'globe', label: 'Globe', Icon: Globe },
  { key: 'truck', label: 'Truck', Icon: Truck },
  { key: 'package', label: 'Package', Icon: Package },
  { key: 'box', label: 'Box', Icon: Box },
  { key: 'move', label: 'Move', Icon: Move },
  { key: 'clipboard-list', label: 'Clipboard', Icon: ClipboardList },
  { key: 'clipboard-check', label: 'Clipboard check', Icon: ClipboardCheck },
  { key: 'file-text', label: 'Document', Icon: FileText },
  { key: 'folder', label: 'Folder', Icon: Folder },
  { key: 'book-text', label: 'Book', Icon: BookText },
  { key: 'search', label: 'Search', Icon: Search },
  { key: 'send', label: 'Send', Icon: Send },
  { key: 'mail', label: 'Mail', Icon: Mail },
  { key: 'ticket', label: 'Ticket', Icon: Ticket },
  { key: 'headphones', label: 'Support', Icon: Headphones },
  { key: 'bell', label: 'Bell', Icon: Bell },
  { key: 'calendar', label: 'Calendar', Icon: Calendar },
  { key: 'clock', label: 'Clock', Icon: Clock },
  { key: 'download', label: 'Download', Icon: Download },
  { key: 'dollar-sign', label: 'Dollar', Icon: DollarSign },
  { key: 'receipt', label: 'Receipt', Icon: Receipt },
  { key: 'wallet', label: 'Wallet', Icon: Wallet },
  { key: 'shield', label: 'Shield', Icon: Shield },
  { key: 'shield-check', label: 'Shield check', Icon: ShieldCheck },
  { key: 'settings', label: 'Settings', Icon: Settings },
  { key: 'wrench', label: 'Wrench', Icon: Wrench },
  { key: 'star', label: 'Star', Icon: Star },
  { key: 'external-link', label: 'External link', Icon: ExternalLink },
  { key: 'layout-dashboard', label: 'Dashboard', Icon: LayoutDashboard },
];

const BY_KEY = new Map<string, LucideIcon>(ICON_LIBRARY.map((e) => [e.key, e.Icon]));

export function iconFor(key: string | null | undefined): LucideIcon {
  return (key && BY_KEY.get(key)) || FileText;
}

export function isKnownIcon(key: string | null | undefined): boolean {
  return !!key && BY_KEY.has(key);
}
